import * as d3 from "d3";
import { compose, prop } from "ramda";
import { targetColor } from "utils/colors";
import { getPeriod, previousPeriod } from "utils/periods";
import { measurementByPeriod, extractValue } from "utils/measurement";
export function initBarchart(chart, svg) {
  chart.append("g").attr("class", "latestMeasurementGroup");
  chart.append("g").attr("class", "previousMeasurementGroup");
  chart.append("g").attr("class", "ciGroup");
  svg.append("g").attr("class", "hover-description-group");
  svg.append("g").attr("class", "manymeasure-reich-target-group");
  var description = svg.append("g").attr("transform", "translate(0,0)").attr("opacity", 0).attr("class", "tooltip").attr("pointer-events", "none");
  description.append("rect").attr("width", 220).attr("height", 70).attr("stroke-width", 3).attr("fill", "white").attr("z-index", 5);
  description.append("text").attr("class", "value").attr("font-weight", "600");
  description.append("text").attr("class", "organization").attr("font-size", "15px").attr("transform", "translate(12,56)");
  return description;
}
export function updateReichAverage(_ref) {
  var measurementsWithMetadata = _ref.measurementsWithMetadata,
    svg = _ref.svg,
    margin = _ref.margin,
    reichAverage = _ref.reichAverage,
    xScale = _ref.xScale,
    height = _ref.height,
    dateTo = _ref.dateTo,
    periodType = _ref.periodType;
  var reichData = measurementsWithMetadata.find(function (measurement) {
    return measurement.organizationId === "SE";
  });
  var reichAverageFunc = function reichAverageFunc() {
    if (!reichData) return [];
    var measurement = periodType && dateTo && measurementByPeriod(getPeriod(periodType, dateTo), reichData.measurements);
    var value = extractValue(null, measurement);
    return value === null ? [] : [value];
  };
  var data = reichAverage ? reichAverageFunc() : [];
  var padding = 4;
  var selection = svg.selectAll(".manymeasure-reich-target-group").selectAll(".manymeasure-reich-target-value").data(data);
  var created = selection.enter().append("line").attr("transform", "translate(0, ".concat(margin.top + padding, ")")).attr("x1", function () {
    return xScale(0);
  }).attr("x2", function () {
    return xScale(0);
  }).attr("y1", 0).attr("y2", height - padding).attr("class", "manymeasure-reich-target-value").attr("stroke-width", 3).attr("stroke-dasharray", "3,3").style("stroke", "#8156aa").style("fill", "none");
  selection.merge(created).transition().ease(d3.easeQuad).duration(400).attr("x1", function (d) {
    return xScale(d);
  }).attr("x2", function (d) {
    return xScale(d);
  }).attr("y1", 0).attr("y2", height - padding).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top + padding, ")"));
  selection.exit().transition().ease(d3.easeQuad).duration(400).style("opacity", "0").remove();
}
export function updateSoughtValue(_ref2) {
  var svg = _ref2.svg,
    margin = _ref2.margin,
    target = _ref2.target,
    hydratedTargets = _ref2.hydratedTargets,
    xScale = _ref2.xScale,
    height = _ref2.height;
  var data = target && hydratedTargets || [];
  var padding = 4;
  var selection = svg.selectAll(".hover-description-group").selectAll(".manymeasure-target-value").data(data);
  var created = selection.enter().append("line").attr("transform", "translate(0,".concat(margin.top + padding, ")")).attr("x1", function () {
    return xScale(0);
  }).attr("x2", function () {
    return xScale(0);
  }).attr("y1", 0).attr("y2", height - padding).attr("class", function (d, idx) {
    return "manymeasure-target-value target".concat(idx);
  }).attr("stroke-width", 3).attr("stroke-dasharray", "3,3").style("stroke", function (d, idx) {
    return targetColor(idx);
  }).style("fill", "none");
  selection.merge(created).transition().ease(d3.easeQuad).duration(400).attr("x1", function (d) {
    return xScale(d.value || d.Value);
  }).attr("x2", function (d) {
    return xScale(d.value || d.Value);
  }).attr("y1", 0).attr("y2", height - padding).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top + padding, ")"));
  selection.exit().transition().ease(d3.easeQuad).duration(400).style("opacity", "0").remove();
}
export function updateLatestMeasurements(_ref3) {
  var measurementsWithMetadata = _ref3.measurementsWithMetadata,
    content = _ref3.content,
    barWidth = _ref3.barWidth,
    margin = _ref3.margin,
    color = _ref3.color,
    periodType = _ref3.periodType,
    units = _ref3.units,
    calcYPos = _ref3.calcYPos,
    genderOpacity = _ref3.genderOpacity,
    paddedBarHeight = _ref3.paddedBarHeight,
    dateTo = _ref3.dateTo;
  var unitlistIdx = function unitlistIdx(id) {
    return units.indexOf(id);
  };
  var currentMeasurement = periodType && dateTo ? measurementByPeriod(getPeriod(periodType, dateTo)) : function () {
    return 0;
  };
  var selection = content.selectAll(".latestMeasurementGroup").selectAll("rect").data(measurementsWithMetadata, function (d) {
    return "".concat(d.measureId, "_").concat(d.organizationId);
  });
  selection.enter().append("rect").attr("transform", function (d, i) {
    return "translate(".concat(margin.left, ",").concat(calcYPos(i), ")");
  }).attr("class", function (d) {
    return "".concat(color(unitlistIdx(d.organizationId), d.organizationId).className, " latestMeasurements");
  }).style("fill", function (d) {
    return color(unitlistIdx(d.organizationId), d.organizationId).hex;
  }).attr("height", paddedBarHeight).merge(selection).transition("transitionLatestMeasurements").ease(d3.easeQuad).duration(400).attr("class", function (d) {
    return "".concat(color(unitlistIdx(d.organizationId), d.organizationId).className, " latestMeasurements");
  }).style("fill", function (d) {
    return color(unitlistIdx(d.organizationId), d.organizationId).hex;
  }).style("opacity", genderOpacity).attr("transform", function (d, i) {
    return "translate(".concat(margin.left, ",").concat(calcYPos(i), ")");
  }).attr("height", paddedBarHeight).attr("width", compose(barWidth, currentMeasurement, prop("measurements")));
  selection.exit().remove();
}
export function updatePreviousMeasurements(_ref4) {
  var measurementsWithMetadata = _ref4.measurementsWithMetadata,
    content = _ref4.content,
    margin = _ref4.margin,
    barWidth = _ref4.barWidth,
    previousBarHeight = _ref4.previousBarHeight,
    color = _ref4.color,
    paddedBarHeight = _ref4.paddedBarHeight,
    calcYPos = _ref4.calcYPos,
    previous = _ref4.previous,
    periodType = _ref4.periodType,
    dateTo = _ref4.dateTo,
    units = _ref4.units;
  var data = previous ? measurementsWithMetadata : [];
  var unitlistIdx = function unitlistIdx(id) {
    return units.indexOf(id);
  };
  var _previousPeriod = periodType && dateTo && previousPeriod(periodType, getPeriod(periodType, dateTo));
  var previousMeasurement = _previousPeriod && measurementByPeriod(_previousPeriod);
  var barColor = function barColor(_color) {
    var opacity = -80;
    var hexValue = _color.replace(/^#/, "").replace(/../g, function (_color) {
      return "0".concat(Math.min(255, Math.max(0, parseInt(_color, 16) + opacity)).toString(16)).substr(-2);
    });
    return "#".concat(hexValue);
  };
  var selection = content.selectAll(".previousMeasurementGroup").selectAll("rect").data(data, function (d) {
    return "".concat(d.measureId, "_").concat(d.organizationId);
  });
  var created = selection.enter().append("rect").style("fill", function (d) {
    return barColor(color(unitlistIdx(d.organizationId), d.organizationId).hex);
  }).style("opacity", ".75").attr("transform", function (d, i) {
    return "translate(".concat(margin.left, ",").concat(calcYPos(i) + paddedBarHeight - previousBarHeight, ")");
  });
  selection.merge(created).attr("height", previousBarHeight).transition().ease(d3.easeQuad).duration(400).style("fill", function (d) {
    return barColor(color(unitlistIdx(d.organizationId), d.organizationId).hex);
  }).attr("transform", function (d, i) {
    return "translate(".concat(margin.left, ",").concat(calcYPos(i) + paddedBarHeight - previousBarHeight, ")");
  }).attr("width", compose(barWidth, previousMeasurement, prop("measurements")));
  selection.exit().remove();
}
export function updateCi(_ref5) {
  var content = _ref5.content,
    ci = _ref5.ci,
    measurementsWithMetadata = _ref5.measurementsWithMetadata,
    margin = _ref5.margin,
    xScale = _ref5.xScale,
    paddedBarHeight = _ref5.paddedBarHeight,
    dateTo = _ref5.dateTo,
    periodType = _ref5.periodType,
    metadata = _ref5.metadata,
    calcYPos = _ref5.calcYPos;
  var data = ci ? measurementsWithMetadata : [];
  var currentMeasurement = periodType && dateTo ? measurementByPeriod(getPeriod(periodType, dateTo)) : function () {
    return 0;
  };
  var isProcent = metadata.measureUnit === "%";
  var getLow = function getLow(d) {
    return isProcent && d.confidenceInterval.low < 0 ? xScale(0) : xScale(d.confidenceInterval.low);
  };
  var getHigh = function getHigh(d) {
    return isProcent && d.confidenceInterval.high > 100 ? xScale(100) : xScale(d.confidenceInterval.high);
  };
  var selection = content.selectAll(".ciGroup").selectAll(".lineGroup").data(data, function (d) {
    return "".concat(d.measureId, "_").concat(d.organizationId);
  });
  var getPos = function getPos(d, i, type) {
    var pos = {
      x1: [getLow(d), getLow(d), getHigh(d)],
      x2: [getHigh(d), getLow(d), getHigh(d)]
    };
    return pos[type][i];
  };
  var lineGroup = selection.enter().append("g").attr("class", "lineGroup").attr("transform", function (d, i) {
    return "translate(".concat(margin.left, ",").concat(calcYPos(i) + paddedBarHeight / 2, ")");
  });
  var groups = selection.merge(lineGroup);
  groups.transition().ease(d3.easeQuad).duration(400).attr("transform", function (d, i) {
    return "translate(".concat(margin.left, ",").concat(calcYPos(i) + paddedBarHeight / 2, ")");
  });
  selection.exit().remove();
  var extractCi = function extractCi(d) {
    return d && d.confidenceInterval && (d.confidenceInterval.low || d.confidenceInterval.low === 0) && (d.confidenceInterval.high || d.confidenceInterval.high === 0) ? [d, d, d] : [];
  };
  var ciBound = groups.selectAll(".ciLine").data(compose(extractCi, currentMeasurement, prop("measurements")));
  ciBound.enter().append("line").attr("class", "ciLine").attr("x1", function (d, i) {
    return getPos(d, i, "x1");
  }).attr("x2", function (d, i) {
    return getPos(d, i, "x2");
  }).attr("y1", function (d, i) {
    return i === 0 ? 0 : -5;
  }).attr("y2", function (d, i) {
    return i === 0 ? 0 : 5;
  }).style("stroke", "black").style("stroke-width", 1).merge(ciBound).style("opacity", 0).transition().ease(d3.easeQuad).duration(400).style("opacity", 1).attr("x1", function (d, i) {
    return getPos(d, i, "x1");
  }).attr("x2", function (d, i) {
    return getPos(d, i, "x2");
  });
  ciBound.exit().transition().ease(d3.easeQuad).duration(400).style("opacity", "0").remove();
}